export default "__VITE_ASSET__B8Tf8jKr__"